export default __webpack_public_path__ + "wave-encoderWorker.min.9f737c9.js";